import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import { dateMiladi, dateMiladiToShamsi, shamsiDate } from "../../../../../../method/date";


let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',

    },
    crad: {
        padding: '5px 15px',
        margin: 10,
        borderRadius: 27,
        cursor:'pointer',
        '&:hover':{
            backgroundColor: 'rgba(230,0,1,0.2)',
            color: '#E60001'
        }
    },
    activeItem: {
        backgroundColor: 'rgba(230,0,1,0.2)',
        color: '#E60001'
    },
    desc:{
        margin:0
    }

}))

export default function Index() {

    let classes = useStyles();
    const [selectedTime, setSelectedTime] = useState(null);

    const addDays = (date, days) => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const addMonths = (date, months) => {
        const result = new Date(date);
        result.setMonth(result.getMonth() + months);
        return result;
    }

    const addYears = (date, years) => {
        const result = new Date(date);
        result.setFullYear(result.getFullYear() + years);
        return result;
    }

    const today = new Date();

    const oneWeekLater = addDays(today, 7);
    const oneMonthLater = addMonths(today, 1);
    const threeMonthsLater = addMonths(today, 3);
    const sixMonthsLater = addMonths(today, 6);
    const oneYearLater = addYears(today, 1);
    const twoYearsLater = addYears(today, 2);


    const timeOptions = [
        { label: 'هفته', value: 'oneWeekLater' },
        { label: '1 ماه', value: 'oneMonthLater' },
        { label: '3 ماه', value: 'threeMonthsLater' },
        { label: '6 ماه', value: 'sixMonthsLater' },
        { label: '1 سال', value: 'oneYearLater' },
        { label: '2 سال', value: 'twoYearsLater' },
    ];

    const handleClick = (timeValue) => {
        setSelectedTime(timeValue);
        switch (timeValue) {
            case 'oneWeekLater':
                handelFilter(oneWeekLater);
                break;
            case 'oneMonthLater':
                handelFilter(oneMonthLater);
                break;
            case 'threeMonthsLater':
                handelFilter(threeMonthsLater);
                break;
            case 'sixMonthsLater':
                handelFilter(sixMonthsLater);
                break;
            case 'oneYearLater':
                handelFilter(oneYearLater);
                break;
            case 'twoYearsLater':
                handelFilter(twoYearsLater);
                break;
            default:
                console.warn('Invalid time option');
        }
    };


    const handelFilter = (data) => {
        if (!data) return

    }
    return (
        <div onClick={() => handelFilter()} className={classes['root']}>
            {timeOptions.map(option => (
                <div
                    key={option.value}
                    className={`${classes['crad']} ${option.value === selectedTime? classes['activeItem']:null}`}
                    onClick={() => handleClick(option.value)} 
                    >
                    <p className={classes['desc']}>{option.label}</p>
                </div>
            ))}
        </div>)
}
